import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import "./home.css";
import Latastupdate from "../../components/latestUpdate/Latastupdate";
import Projects from "../../components/projects/Projects";
import FacebookFeed from "../../components/facebook-feed/FacebookFeed";
import YoutubeFeed from "../../components/youtube-feed/YoutubeFeed";
import Caranddare from "../../components/care-and-dare/careanddare";

import Testimonial from "../../components/testimonial/Testimonial";
import HowItWorks from "../../components/howitworks/HowItWorks";
import DataAndResearchData from "../../components/data_and_research_reports/DataAndResearchData";
import HeroSlider from "../../components/hero-slider/HeroSlider"; 

const Home = () => {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const detectLanguage = () => {
      const el = document.querySelector(".nav-link");
      if (!el) return;

      const text = el.innerText;
      if (/[\u0D80-\u0DFF]/.test(text)) {
        setLang("si"); // Sinhala
      } else if (/[\u0B80-\u0BFF]/.test(text)) {
        setLang("ta"); // Tamil
      } else {
        setLang("en"); // Default
      }
    };

    const observer = new MutationObserver(detectLanguage);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    detectLanguage(); // Initial check

    return () => observer.disconnect();
  }, []);

  const headingStyle = {
    fontSize:
      lang === "si" ? "70px" : lang === "ta" ? "50px" : "80px",
    lineHeight: "1.1",
  };

  return (
    <div>
      {/* <div className="header home ">
        <div className="container-7 w-container">
          <h5 className="heading-13" style={headingStyle}>
            <br />
            ALONE, SO LITTLE.
            <br />
            TOGETHER, SO MUCH…
          </h5>
        </div>
      </div> */}

   <HeroSlider />      

      {/* <div id="projects" className="section _1">
        <div className="w-container">
          <h2 className="home---heading-2">
            Gammadda-(The heart of the village); An initiative for the people by the people
          </h2>
          <p className="main_p">
            Rural Sri Lanka is an enigma. Over 35,000 villages, cross-divided into a myriad administrative regions ranging
            from 09 Provinces to 14,000+ GS Divisions. Each village, each locality, has its own endemic challenges.
            Understanding these issues is a profound undertaking that requires an investment in time, and hard miles. The
            uniqueness of Gammadda is, it listens to the people first. This is our core strength. We walk for thousands of
            miles each year, spending time with the people. Listening to their problems but equally importantly, to their
            solutions. It is learnings gleaned out of these experiences that we use to as the foundation of our rural
            development projects.
          </p>
          <div className="divider grey"></div>
        </div>
      </div> */}

      <div id="projects" className="section _1">
        <div className="w-container">
          <h2 className="home---heading-2">
            “Sahana Yathra” - Emergency Relief From Gammadda 
          </h2>
          <p className="main_p">
            Gammadda, Sri Lanka’s largest grassroots rural development network, stands in steadfast support of the hundreds of thousands of people whose lives were destroyed by Cyclone Ditwah, the storm that left a trail of destruction across the island. The death toll currently stands at 627 with 190 missing, and 1.8 million affected.
True to its motto “For The People, By The People”, the Gammadda Team works tirelessly to deliver relief in all areas of the country, around the clock.
Within hours of Cyclone Ditwah’s landfall, Gammadda’s “Sahana Yathra” program was put into action, mobilizing resources to rush to the aid of affected communities.
Starting from the first day of the disaster, Sahana Yathra trucks have been rolling out from multiple locations in the capital Colombo, loaded with scientifically designed packs of bottled water, food, medicine, etc. Contributions flow in from the public, schools and corporate sector, with thousands of volunteers assisting the Gammadda Team.
          </p>
          <div className="divider grey"></div>
        </div>
      </div>

      <Caranddare />
      <Latastupdate />
      <Projects />
      <FacebookFeed/>
      <YoutubeFeed/>
     

      <div id="projects" className="section">
        <div className="container" style={{ maxWidth: "940px" }}>
          <h2 className="gm---heading-2">
            <strong>Philosophy in Action - See what we do</strong>
          </h2>
          <div className="row">
            <div className="col-12">
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/X_1lcGMfWgY?rel=0&controls=1&autoplay=0&mute=0&start=0"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="Philosophy in Action - See what we do"
                ></iframe>
              </div>
            </div>
            <div className="w-200" style={{ margin: "10px" }}></div>
            <div className="col-md-6 col-12 mb-3">
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/VwO89bIr1ao?rel=0&controls=1&autoplay=0&mute=0&start=0"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="අලුත් හෙටක් උදෙසා හදවත් ගොඩනගමු...."
                ></iframe>
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="video-container">
                <iframe
                  src="https://www.youtube.com/embed/J_VMliRZ9zU?rel=0&controls=1&autoplay=0&mute=0&start=0"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title="Let's unite our hearts for a prosperous future..."
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    <Testimonial />
    <HowItWorks />
    <DataAndResearchData/>
    </div>
  );
};

export default Home;
